// Bill_view.jsx
const Bill_view = () => {
  return (
    <div className="mobile-center-wrapper">
      <div className="space-y-4 mb-16">
        <div className="p-4 sm:p-6 bg-white rounded-xl shadow">
          <h2 className="text-lg sm:text-xl font-bold mb-4">지출/청구 상세페이지</h2>
        </div>
      </div>
    </div>
  );
};

export default Bill_view;
